import React, { useCallback, useContext, useEffect, useState } from "react";
import NavBar from "../components/Nav";
import BackTop from "../components/BackToTop";
import Footer from "../components/Footer";
import GoToTop from "../components/Top";
import { Link } from "react-router-dom";
import apiRequest from "../utils/apiRequest";
import { Store } from "../context/store";
import FadeLoader from "react-spinners/FadeLoader";
import Pagination from "react-bootstrap/Pagination";
import { useSearchParams } from "react-router-dom";

function Properties() {
  let store = useContext(Store);
  let [baseUrl] = store.url;
  let [propertyData, setProperies] = useState([]);
  let [loading, setLoading] = useState(false);
  let [, setError] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();

  const [totalPages, setTotalPages] = useState(1);
  const page = parseInt(searchParams.get("page")) || 1;

  const loadProperties = useCallback(async () => {
    setLoading(true);
    try {
      const url = `${baseUrl}/properties?page=${page}`;
      const { data } = await apiRequest(url, "GET", null, null);
      setProperies(data.properties);
      setTotalPages(data.totalPages);
    } catch (error) {
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [baseUrl, page, setError]);

  useEffect(() => {
    loadProperties();
  }, [loadProperties]);

  const handlePageChange = (newPage) => {
    setSearchParams({ page: newPage });
  };

  return (
    <>
      <div className="container-fluid px-3" style={{ background: "white" }}>
        <title>Properties | RoyalMines Property</title>
        <meta
          name="description"
          content="Find the best real estate and properties in Abuja and Nigeria. Explore a wide range of residential and commercial properties, including houses, apartments, land, and more. Discover trusted real estate agents, listings, and resources to help you buy, sell, or rent properties in Abuja and across Nigeria."
        />
        <meta
          name="keywords"
          content="real estate, properties, Abuja, Nigeria, houses, apartments, land, mortgages, mortgage, real estate agents, listings, buy, sell, rent, residential, commercial, apartments, houses, land, real estate solutions, real estate company"
        />

        <NavBar properties={"active"} />
        <BackTop />

        {/*  Property List Start  */}
        <div className="container-xxl py-5 properties-page">
          <div className="container">
            {/* header */}
            <div className="property-header text-center properties-hero">
              <div
                className="mb-5 wow fadeInUp"
                data-wow-delay="0.1s"
                style={{ maxWidth: "600px", margin: "0 auto" }}
              >
                <span className="properties-kicker">Discover</span>
                <h1 className="mb-3">Our Properties</h1>
                <p className="mb-0 properties-hero-copy">
                  Explore premium homes and investment opportunities with clear
                  details and trusted support.
                </p>
              </div>
            </div>

            <div className="row justify-content-center align-items-center g-0 gx-5 mb-4">
              <div className="col-lg-12">
                <div className="text-center mx-auto wow slideInLeft" data-wow-delay="0.1s">
                  <h2 className="mb-2">Property Listing</h2>
                  <p className="mb-0">
                    Find homes that match your lifestyle in one streamlined,
                    modern listing experience.
                  </p>
                </div>
              </div>
            </div>

            <div className="tab-content">
              <div id="tab-1" className="tab-pane fade show p-0 active">
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "50vh",
                    }}
                  >
                    <FadeLoader color="#0078e7" />
                  </div>
                ) : (
                  <div className="row g-4">
                    {propertyData?.length === 0 ? (
                      <div>
                        <h3 className="text-center">No Property Available.</h3>
                      </div>
                    ) : (
                      propertyData?.map((e, i) => {
                        return (
                          <div
                            className="col-lg-4 col-md-6 wow fadeInUp"
                            data-wow-delay="0.1s"
                            key={i}
                          >
                            <Link to={`/property/${e.id}`} className="property-card-link">
                              <article className="property-item property-card-modern rounded overflow-hidden h-100">
                                <div className="position-relative overflow-hidden img-fluid-fixed property-media">
                                  <img
                                    className="img-fluid"
                                    src={e.images[0]}
                                    alt={e.title}
                                  />
                                  <div className="property-badge status-badge">{e.status}</div>
                                  {e.propertyType ? (
                                    <div className="property-badge type-badge">{e.propertyType}</div>
                                  ) : null}
                                </div>
                                <div className="p-4">
                                  <h5 className="d-block h5 property-title mb-2">{e.title}</h5>
                                  <p className="property-address mb-2">
                                    <i className="fa fa-map-marker-alt text-dark me-2"></i>
                                    {e.address}
                                  </p>
                                  <span className="property-view-more">
                                    View details <i className="fa fa-arrow-right ms-2"></i>
                                  </span>
                                </div>
                              </article>
                            </Link>
                          </div>
                        );
                      })
                    )}
                  </div>
                )}

                {/* Pagination */}
                {propertyData?.length > 0 ? (
                  <div>
                    <Pagination
                      className="my-5 wow slideInUp"
                      data-wow-delay="0.1s"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Pagination.Prev
                        disabled={page === 1}
                        onClick={() => handlePageChange(page - 1)}
                      />

                      {/* Render page items and ellipses dynamically */}
                      {totalPages <= 10 ? (
                        // Render all page items if total pages are less than or equal to 10
                        Array.from({ length: totalPages }, (_, i) => (
                          <Pagination.Item
                            key={i + 1}
                            active={page === i + 1}
                            onClick={() => handlePageChange(i + 1)}
                          >
                            {i + 1}
                          </Pagination.Item>
                        ))
                      ) : (
                        <>
                          {/* Render first 5 page items */}
                          {Array.from(
                            { length: Math.min(5, totalPages) },
                            (_, i) => (
                              <Pagination.Item
                                key={i + 1}
                                active={page === i + 1}
                                onClick={() => handlePageChange(i + 1)}
                              >
                                {i + 1}
                              </Pagination.Item>
                            )
                          )}

                          {/* Ellipsis for hidden pages in the middle */}
                          <Pagination.Ellipsis />

                          {/* Render last 5 page items (or less if total pages are less than 10) */}
                          {Array.from(
                            { length: Math.min(5, totalPages) },
                            (_, i) => {
                              const adjustedIndex = totalPages - i;
                              return (
                                <Pagination.Item
                                  key={adjustedIndex}
                                  active={page === adjustedIndex}
                                  onClick={() =>
                                    handlePageChange(adjustedIndex)
                                  }
                                >
                                  {adjustedIndex}
                                </Pagination.Item>
                              );
                            }
                          )}
                        </>
                      )}

                      <Pagination.Next
                        disabled={page === totalPages}
                        onClick={() => handlePageChange(page + 1)}
                      />
                    </Pagination>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/*  Property List End  */}

        <div>
          <Footer />
        </div>
      </div>
      <GoToTop />
    </>
  );
}

export default Properties;
